import React from 'react';

import { baseStyles } from '../styles';
import 'react-phone-number-input/style.css';
import 'sweetalert2/dist/sweetalert2.css';

import { AuthStep } from '../types';
import { useAuthStep } from '../context/AuthStepContext';
import EmailInputForm from './EmailInputForm';
import PinInputForm from './PinInputForm';
import { PhoneCodeForm } from './PhoneCodeForm';
import { RegisterSuccess } from '..';
import { CodeForm } from './CodeForm';
import PhoneInputForm from './PhoneInputForm';
import { ClinicianSignUpForm } from './ClinicianSignUpForm';

const SignInForm: React.FC = () => {
  const { currentStep, isLoading } = useAuthStep();

  if (isLoading) {
    return (
      <div style={baseStyles.clientReg}>
        <h4>Verifying, please wait...</h4>
      </div>
    );
  }

  switch (currentStep) {
    case AuthStep.EMAIL:
      return <EmailInputForm />;
    case AuthStep.PIN:
      return <PinInputForm />;
    case AuthStep.PHONE:
      return <PhoneInputForm />;
    case AuthStep.COMPLETE:
      return <RegisterSuccess />;
    case AuthStep.EMAIL_CODE:
      return <CodeForm />;
    case AuthStep.DETAILS:
      return <ClinicianSignUpForm />;
    case AuthStep.PHONE_CODE:
      return <PhoneCodeForm />;
    default:
      return null;
  }
};

export { SignInForm };
